import React, { Component } from "react";
import BootstrapCarousel from "./BootstrapCarousel";

class SlideEvents2 extends Component {
  state = {
    controls: true,
    indicators: true,
    pauseOnHover: false,
    interval: 3000,
    nextIcon: <img alt="seta slide esquerda" src="images/arrow_right.png" />,
    prevIcon: <img alt="seta slide direita" src="images/arrow_left.png" />,
    slides: [
      {
        id: 0,
        idSlide: "slide3_img1",
        imgSrc: "images/slide3_img1.png",
        altImg: "First slide Third caroussel",
      },
      {
        id: 1,
        idSlide: "slide3_img2",
        imgSrc: "images/slide3_img2.png",
        altImg: "Second slide Third caroussel",
      },
      {
        id: 2,
        idSlide: "slide3_img3",
        imgSrc: "images/slide3_img3.png",
        altImg: "Third slide Third caroussel",
      },
      {
        id: 3,
        idSlide: "slide3_img4",
        imgSrc: "images/slide3_img4.png",
        altImg: "Fourth slide Third caroussel",
      },
      {
        id: 4,
        idSlide: "slide3_img5",
        imgSrc: "images/slide3_img5.png",
        altImg: "Fifth slide Third caroussel",
      },
      {
        id: 5,
        idSlide: "slide3_img6",
        imgSrc: "images/slide3_img6.png",
        altImg: "Sixth slide Third caroussel",
      },
    ],
  };
  render() {
    const {
      controls,
      indicators,
      pauseOnHover,
      interval,
      slides,
      nextIcon,
      prevIcon,
    } = this.state;
    return (
      <div className="slide_container">
        <BootstrapCarousel
          controls={controls}
          indicators={indicators}
          pauseOnHover={pauseOnHover}
          interval={interval}
          slides={slides}
          nextIcon={nextIcon}
          prevIcon={prevIcon}
          openVideoModal={this.props.openVideoModal}
        />
        <div className="slide_hover"></div>
      </div>
    );
  }
}

export default SlideEvents2;
